var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlusTeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5h6.9c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5h-6.9V1.6c0-.8-.7-1.5-1.5-1.5S8.5.8 8.5 1.6v6.9H1.6C.8 8.5.1 9.2.1 10s.7 1.5 1.5 1.5h6.9v6.9c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-6.9z",
    fill: "#009baf"
  })));
}

export default SvgIconPlusTeal;